import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { featureArticles } from '@/mocks/homeData';

export default function FeatureGrid() {
  const { t } = useTranslation();

  if (!featureArticles || featureArticles.length === 0) {
    return null;
  }

  const mainArticle = featureArticles[0];
  const sideArticle1 = featureArticles.length > 1 ? featureArticles[1] : null;
  const sideArticle2 = featureArticles.length > 2 ? featureArticles[2] : null;

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
            {t('feature.title.line1')}
            <span className="text-accent-500"> {t('feature.title.accent1')}</span>
            <br />
            {t('feature.title.accent2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          <Link
            to="/"
            className="group relative rounded-lg overflow-hidden cursor-pointer lg:row-span-2"
          >
            <div className="relative w-full h-[420px] md:h-[560px] lg:h-full">
              <img
                src={mainArticle.imageUrl}
                alt={mainArticle.title}
                className="w-full h-full object-cover object-top"
                title={mainArticle.title}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-semibold whitespace-nowrap mb-3">
                  {mainArticle.tag}
                </span>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-white leading-snug group-hover:text-accent-300 transition-colors duration-300">
                  {mainArticle.title}
                </h3>
                <div className="flex items-center gap-4 mt-3 text-white/60 text-xs">
                  <span>{mainArticle.category}</span>
                  <span>{mainArticle.date}</span>
                  <span>{(mainArticle.views / 10000).toFixed(0)}万阅读</span>
                </div>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-5 md:gap-6">
            {sideArticle1 && (
              <Link
                to="/"
                className="group relative rounded-lg overflow-hidden cursor-pointer flex-1"
              >
                <div className="relative w-full h-[200px] md:h-[260px]">
                  <img
                    src={sideArticle1.imageUrl}
                    alt={sideArticle1.title}
                    className="w-full h-full object-cover object-top"
                    title={sideArticle1.title}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-500/90 text-white text-xs font-semibold whitespace-nowrap mb-2">
                      {sideArticle1.tag}
                    </span>
                    <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug group-hover:text-accent-300 transition-colors duration-300">
                      {sideArticle1.title}
                    </h3>
                    <div className="flex items-center gap-3 mt-2 text-white/55 text-xs">
                      <span>{sideArticle1.category}</span>
                      <span>{sideArticle1.date}</span>
                    </div>
                  </div>
                </div>
              </Link>
            )}

            {sideArticle2 && (
              <Link
                to="/"
                className="group relative rounded-lg overflow-hidden cursor-pointer flex-1"
              >
                <div className="relative w-full h-[200px] md:h-[260px]">
                  <img
                    src={sideArticle2.imageUrl}
                    alt={sideArticle2.title}
                    className="w-full h-full object-cover object-top"
                    title={sideArticle2.title}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-500/90 text-white text-xs font-semibold whitespace-nowrap mb-2">
                      {sideArticle2.tag}
                    </span>
                    <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug group-hover:text-accent-300 transition-colors duration-300">
                      {sideArticle2.title}
                    </h3>
                    <div className="flex items-center gap-3 mt-2 text-white/55 text-xs">
                      <span>{sideArticle2.category}</span>
                      <span>{sideArticle2.date}</span>
                    </div>
                  </div>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}